module.exports = __webpack_public_path__ + "static/media/latinad.c0f35902.svg";